import script from "./OtpInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpInput.vue?vue&type=script&setup=true&lang=js"

import "./OtpInput.vue?vue&type=style&index=0&id=609adb2f&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609adb2f"]])

export default __exports__